import * as Types from '../../__generated__/globalTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetMyNotificationsVariables = Types.Exact<{
  isRead?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  skip?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetMyNotifications = { __typename?: 'Query', getMyNotifications: Array<{ __typename?: 'UserNotificationRecord', id: string, category: string, alertId?: string | null, entityId?: string | null, entityType?: string | null, deviceId?: string | null, title: string, body: string, severity: string, isRead: boolean, readAt?: any | null, screen?: string | null, params?: any | null, createdAt: any }> };


export const GetMyNotificationsDocument = gql`
    query GetMyNotifications($isRead: Boolean, $limit: Int, $skip: Int) {
  getMyNotifications(isRead: $isRead, limit: $limit, skip: $skip) {
    id
    category
    alertId
    entityId
    entityType
    deviceId
    title
    body
    severity
    isRead
    readAt
    screen
    params
    createdAt
  }
}
    `;

/**
 * __useGetMyNotifications__
 *
 * To run a query within a React component, call `useGetMyNotifications` and pass it any options that fit your needs.
 * When your component renders, `useGetMyNotifications` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyNotifications({
 *   variables: {
 *      isRead: // value for 'isRead'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetMyNotifications(baseOptions?: Apollo.QueryHookOptions<GetMyNotifications, GetMyNotificationsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyNotifications, GetMyNotificationsVariables>(GetMyNotificationsDocument, options);
      }
export function useGetMyNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyNotifications, GetMyNotificationsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyNotifications, GetMyNotificationsVariables>(GetMyNotificationsDocument, options);
        }
// @ts-ignore
export function useGetMyNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyNotifications, GetMyNotificationsVariables>): Apollo.UseSuspenseQueryResult<GetMyNotifications, GetMyNotificationsVariables>;
export function useGetMyNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyNotifications, GetMyNotificationsVariables>): Apollo.UseSuspenseQueryResult<GetMyNotifications | undefined, GetMyNotificationsVariables>;
export function useGetMyNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyNotifications, GetMyNotificationsVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyNotifications, GetMyNotificationsVariables>(GetMyNotificationsDocument, options);
        }
export type GetMyNotificationsHookResult = ReturnType<typeof useGetMyNotifications>;
export type GetMyNotificationsLazyQueryHookResult = ReturnType<typeof useGetMyNotificationsLazyQuery>;
export type GetMyNotificationsSuspenseQueryHookResult = ReturnType<typeof useGetMyNotificationsSuspenseQuery>;
export type GetMyNotificationsQueryResult = Apollo.QueryResult<GetMyNotifications, GetMyNotificationsVariables>;